export default "<rmd:a>\n\t<a data-id='href' data-property='href'>\n\t\t<span data-id='body'></span>\n\t</a>\n</rmd:a>";